import { motion } from "framer-motion";
import { useState, useEffect, useRef } from "react";
import { Users, Store, ShoppingBag } from "lucide-react";
import counterImage from "../../Assets/Images/HomeCounter/CanteenImage.jpeg";
import { BASE_URL } from "../../../Api/Config";

const Counter = ({ end, duration = 2, suffix = "", icon: Icon, label }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    let startTime;
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min(
        (currentTime - startTime) / (duration * 1000),
        1
      );
      setCount(Math.floor(progress * end));
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [isVisible, end, duration]);

  return (
    <motion.div
      ref={ref}
      initial={{ y: 30, opacity: 0 }}
      animate={isVisible ? { y: 0, opacity: 1 } : {}}
      transition={{ duration: 0.6 }}
      className="text-center rounded-xl"
    >
      <div className="flex justify-center mb-4">
        <div className="bg-redbg rounded-full p-4">
          <Icon className="w-8 h-8 text-snowtxt" />
        </div>
      </div>
      <h2 className="text-2xl md:text-4xl font-bold text-snowtxt mb-2">
        {count.toLocaleString()}
        {suffix}
      </h2>
      <p className="text-snowtxt text-sm md:text-base font-semibold">
        {label}
      </p>
    </motion.div>
  );
};

const HomeCounter = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  // const getAuthToken = () => localStorage.getItem("token");

  // const fetchStats = async () => {
  //   try {
  //     setLoading(true);
  //     const token = getAuthToken();
  //     const response = await fetch(`${BASE_URL}/admin/stats`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     if (response.ok) {
  //       const data = await response.json();
  //       setStats(data.stats || {});
  //     } else {
  //       console.error("Failed to fetch stats");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching stats:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchStats();
  // }, []);

  // if (!stats) return <p className="text-center p-6">Loading counters...</p>;

  return (
    <section className="py-14 md:py-16 relative">
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="text-center mb-12 px-4"
      >
        <h2 className="text-darktxt text-2xl md:text-4xl font-bold mb-4">
          Our Growing Campus Crew
        </h2>
        <h3 className="text-lightGray text-base md:text-lg font-semibold max-w-2xl mx-auto">
          Thousands of students trust us for their daily meals, and so should
          you!
        </h3>
      </motion.div>

      <div
        style={{ backgroundImage: `url(${counterImage})` }}
        className="relative w-full min-h-[24rem] md:min-h-[22rem] bg-cover bg-center bg-no-repeat bg-fixed flex justify-center items-center"
      >
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 max-w-6xl w-full px-4 sm:px-6 py-8">
          {/* <Counter
            end={stats.totalUsers || 0}
            suffix="+"
            icon={Users}
            label="Happy Students"
          />
          <Counter
            end={stats.totalRestaurants || 0}
            icon={Store}
            label="Canteen Counters"
          />
          <Counter
            end={stats.monthlyOrders || 0}
            suffix="+"
            icon={ShoppingBag}
            label="Daily Orders"
          /> */}
          <Counter end={stats || 1000} suffix="+" icon={Users} label="Happy Students" />
          <Counter end={stats || 10} icon={Store} label="Canteen Counters" />
          <Counter end={stats || 50} suffix="+" icon={ShoppingBag} label="Daily Orders" />
        </div>
      </div>
    </section>
  );
};

export default HomeCounter;